export { default as DataTable } from './DataTable.vue';
